<template>
  <div class="container-fluid main_content">
    <div class="fillter_box row m-0">
      <div class="col-2 offset-10 text-right">
        <common-input
          :placeholder="'차량명, 차량번호'"
          @search="search"
        />
      </div>
    </div>


    <common-data-table
      hover
      :totalPage="totalPage"
      :curPage="curPage"
      :url="'history'"
      class="col-12"
    >
      <template slot="header">
        <b-thead>
          <b-tr>
            <b-th>차량번호</b-th>
            <b-th>년식</b-th>
            <b-th>차량모델</b-th>
            <b-th>소속</b-th>
            <b-th>운전자</b-th>
            <b-th>상태</b-th>
            <b-th>총 주행거리</b-th>
            <b-th>최근검사일</b-th>
            <b-th>소모품 상태</b-th>
            <b-th>진단상태</b-th>
            <b-th>비고</b-th>
          </b-tr>
        </b-thead>
      </template>
      <template slot="body">
        <b-tbody>
          <b-tr v-for="(item, index) in items" :key="index">
            <b-td>{{ item.num }}</b-td>
            <b-td>{{ (item.year) ? item.year + '년' : '' }}</b-td>
            <b-td>
              <router-link :to="{ name: 'HistoryDrive', params:{seq:item.seq}, query: $route.query, hash: $route.hash}"
                           class="text-dark link">
                {{ item.cname | carNameDisplay(item.brand) }}
              </router-link>
            </b-td>
            <b-td>{{ (item.csname) ? '(' + item.csname + ') ' : '' }} {{ item.cssname }}</b-td>
            <b-td>{{ (item.uname) ? item.uname : '' }}</b-td>
            <b-td><span :class="(item.brk === '0') ? 'text-success' : 'text-muted'">{{
                (item.brk === '0') ? '운행' : '주차'
              }}</span>
            </b-td>
            <b-td>{{ item.total_km | comma }}Km</b-td>
            <b-td>{{ item.now_ins }}</b-td>
            <b-td>
              <span class="text-success link_ beta">양호</span>
            </b-td>
            <b-td>
              <span class="text-success link" v-if="item.dtcs_level === '1'">양호</span>
              <span class="text-warning link" v-if="item.dtcs_level === '2'">경고</span>
              <span class="text-danger link" v-if="item.dtcs_level === '3'">긴급</span>
            </b-td>
            <b-td> {{ item.memo }}</b-td>
          </b-tr>
        </b-tbody>
      </template>
    </common-data-table>
  </div>
</template>

<script>
import commonInput from '@/components/common/inputbox/Inputbox'
import commonDataTable from '@/components/common/table/DataTable'
import '@/filter/common'
import ax from '@/api/history'

export default {
  name: 'CarList',
  components: {
    commonInput,
    commonDataTable
  },
  data () {
    return {
      curPage: parseInt(this.$route.query.page) || 1,
      totalPage: 1,
      items: []
    }
  },
  watch: {
    '$route.query': function () {
      this.curPage = parseInt(this.$route.query.page) || 1
      this.init()
    }
  },
  created () {
    this.init()
  },
  methods: {
    search (v) {
      let currentHash = window.location.hash.slice(1)
      if (v) {
        if (v !== currentHash) {
          this.$router.push('#' + v)
        }
      } else {
        if (currentHash) {
          this.$router.push('')
        }
      }
    },
    init () {
      let sk = window.location.hash.slice(1)
      ax.list(this.curPage, sk, (data) => {
        if (data) {
          this.items = data.items
          this.totalPage = data.totalPage
        } else {
          this.items = []
          this.totalPage = 1
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.fillter_box {
  padding: 15px 0px;
}

.custom_table {
  .link {
    position: relative;

    &:after {
      content: ' ';
      color: #ddd;
      width: 13px;
      height: 13px;
      position: absolute;
      top: 2px;
      background-image: url('/img/icon/icons_link_16.png');
      background-size: cover;
    }
  }
}
</style>
